import { IMaxbrainImageQuery } from 'app/library/image-library/interfaces/maxbrain-image.interface';
import { ILandingPageComponentBookedExecutionQuery } from '../interfaces/landing-page-component-booked-execution.query.interface';

export class LandingPageComponentBookedExecution {
    id: string;
    name: string;
    status: string;
    kind: string;
    image: IMaxbrainImageQuery | null;
    version: string;
    type: string;
    selfPaced: boolean;

    constructor(query: ILandingPageComponentBookedExecutionQuery) {
        this.id = query.id.toString();
        this.name = query.name;
        this.status = query.status;
        this.kind = query.kind;
        this.image = query.image || null;
        this.version = query.version;
        this.type = query.type;
        this.selfPaced = !!query.self_paced;
    }
}
